import React, { Component } from 'react';
import Recaptcha from 'react-google-invisible-recaptcha';
import renderHTML from 'react-render-html';
import EventsAppWrapper from '../../events-app-wrapper';
import ViewHeader from '../../components/view-header';
import Loader from '../../components/loader';
import SummaryDetails from '../ssm-homepage/ssm-components/summary-details/summary-details';
import {
  stripStartingAndEndingPTags,
  validatePhoneNumber,
  validateNumber,
  scrollFirstMatchingElementIntoView,
} from '../ssm-homepage/ssm-homepage.actions';
import AliasTable from './components/alias-table/alias-table';
import ReviewTable from './components/review-table/review-table';
import EmailTable from './components/email-table/email-table';
import ForwardedEmailTable from './components/forwarding-table/forwarding-table';
import Button from '../../components/button/button';
import {
  BUSINESS_POP_MAIL_HOME_SCREEN,
  BUSINESS_POP_MAIL_REVIEW_SCREEN,
  DEBUG_MODE,
  TAM_REDIRECT_PATH,
  WINDOW_START_POSITION,
} from '../../app-constants';
import { prepareSubmitData, prepareContactFormArr, validateContactForm } from './business-pop-mail.actions';
import { ContactForm } from './components/contact-form/contact-form';
import './business-pop-mail.css';

class BusinessPopMailView extends Component {
  state ={
    emailSelectionCheckedStatus: {},
    currentScreen: BUSINESS_POP_MAIL_HOME_SCREEN,
    contactFormValue: {},
    contactFormError: {},

  };

  componentDidMount() {
    this.updateReloadData(prepareContactFormArr());
  }

  onEmailSelectionStatusChanged = (radioButtonClicked) => {
    const { id } = radioButtonClicked;
    const newEmailSelectionCheckedStatus = { ...this.state.emailSelectionCheckedStatus };
    delete newEmailSelectionCheckedStatus.migrateall;
    delete newEmailSelectionCheckedStatus.cancelall;
    const splittedId = id.split('|');
    const emailUsed = splittedId[1];
    const optionSelected = splittedId[0];
    newEmailSelectionCheckedStatus[emailUsed] = optionSelected;
    this.setState({ emailSelectionCheckedStatus: newEmailSelectionCheckedStatus });
  }

  onChange = (event) => {
    const inputType = event.target.id;
    const inputValue = event.target.value;
    const contactFormValue = this.state.contactFormValue;
    if (inputType === 'contactField') {
      if (inputValue.length < 11 && validateNumber(inputValue)) {
        contactFormValue[inputType] = inputValue;
        this.setState({ contactFormValue });
      }
    } else {
      contactFormValue[inputType] = inputValue;
      this.setState({ contactFormValue });
    }
  }

  onBlur = (event) => {
    const inputType = event.target.id;
    const inputValue = event.target.value;
    const contactFormError = this.state.contactFormError;
    if (inputType === 'contactField') {
      const callBackPhoneNumberhasError = !validatePhoneNumber(inputValue) || inputValue.length !== 10;
      contactFormError[inputType] = callBackPhoneNumberhasError;
    } else if (inputType === 'firstName' || inputType === 'lastName') {
      contactFormError[inputType] = (inputValue === '');
    }
    this.setState({ contactFormError });
  }

  onHandleReview = () => {
    const { mailboxAffected } = this.props.customerData;
    const atleastOneMigratePresent = mailboxAffected.some(mailbox => this.state.emailSelectionCheckedStatus &&
      this.state.emailSelectionCheckedStatus[mailbox] === 'Migrate');

    const validateContactFormRes = validateContactForm(atleastOneMigratePresent, this.state.contactFormValue, this.state.contactFormError);

    if (atleastOneMigratePresent && validateContactFormRes.error) {
      scrollFirstMatchingElementIntoView('.form-error');
      this.setState({ contactFormError: validateContactFormRes.formErrors });
    } else {
      this.setState({ currentScreen: BUSINESS_POP_MAIL_REVIEW_SCREEN });
      window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
    }
  }
  onHandleEdit = () => {
    this.setState({ currentScreen: BUSINESS_POP_MAIL_HOME_SCREEN });
    window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
  }

  onHandleSubmit = () => {
    this.recaptcha.execute();
  }

  onResolved = () => {
    if (DEBUG_MODE) {
      console.log('RESOLVED1', this.recaptcha.getResponse()); // eslint-disable-line
    }
    const { mailboxAffected } = this.props.customerData;
    const { submitBusinessPopMail } = this.props.actions;
    const dataForSubmit = prepareSubmitData(mailboxAffected,
      this.state.emailSelectionCheckedStatus,
      this.recaptcha.getResponse(), this.state.contactFormValue);
    submitBusinessPopMail(dataForSubmit);
  };

  onError= () => {
    if (DEBUG_MODE) {
      console.log('Facing network error .Please check you internet connection'); // eslint-disable-line
    }
  };

  onExpired= () => {
    if (DEBUG_MODE) {
      console.log('token got expired'); // eslint-disable-line
    }
  };

  onAllSelectionChanged = (radioButtonClicked) => {
    const {
      mailboxAffected,
    } = this.props.customerData;
    const newEmailSelectionCheckedStatus = {};
    mailboxAffected.forEach((mailBox) => {
      if (radioButtonClicked.id === 'migrateall') {
        newEmailSelectionCheckedStatus[mailBox] = 'Migrate';
      } else {
        newEmailSelectionCheckedStatus[mailBox] = 'Cancel';
      }
    });
    if (radioButtonClicked.id === 'migrateall') {
      newEmailSelectionCheckedStatus.migrateall = true;
    } else {
      newEmailSelectionCheckedStatus.cancelall = true;
    }
    this.setState({ emailSelectionCheckedStatus: newEmailSelectionCheckedStatus });
  }

  setupTAMRedirect = () => {
    setTimeout(() => {
      window.open(TAM_REDIRECT_PATH, '_blank');
    }, 5000);
  }

  updateReloadData = (reLoadData) => {
    this.setState(reLoadData);
  };

  render() {
    if (this.props.dataLoaded && this.props.userSubmitted === false && this.props.enableNoAction === false) {
      const
        {
          businessMailServiceExit: {
            title: pageTitle,
            shortSummary,
            browserTabText,
            summaryTitle,
            summary,
            aliasEmailAddress,
            aliasEmailAddressText,
            emailForwarding: emailForwardingText,
            emailNotGoingToAccountHolderPre,
            emailNotGoingToAccountHolderPost,
            smtpMailbox: smtpMailboxText,
            dns3rdPartyPre,
            dns3rdPartyCenter,
            dns3rdPartyPost,
            emailOnServerDownloaded,
            usingOffice365,
            customerStrayEmail,
            mailboxHostedAnotherParty,
            affectedMailAddressesHeading,
          },
          migrate: {
            summaryTitle: whatsNextSummaryTitle,
            summary: whatsNextSummary,
            summaryv2: whatsNextSummaryV2,
            footerText,
            emailText,
            actionText,
            bulkActionsText,
            migrateRadioText,
            cancelRadioText,
            migrateAllRadioText,
            cancelAllRadioText,
            forwardingEmailText,
            currentServicesText,
            contactFieldDescription,
            formFields,
          },
          review: {
            title: reviewTitle,
            migrationNote,
            summaryTitle: reviewSummaryTitle,
            summary: reviewSummary,
          },
          actionButtons: {
            reviewAndSubmitButtonText,
            editButtonText,
            submitButtonText,
          },
        } = this.props.authorableContent;
      const {
        aliasMail,
        mailboxAffected,
        emailForwarding,
        accountHolder,
        domain,
        thirdPartyDNS,
        mailOnServer,
        office365,
        strayMail,
        altMailboxProvider,
        forwardedMailList,
        smtpMailbox,
      } = this.props.customerData;
      const contentHeader = {
        heading: pageTitle,
        description: '',
      };
      const reviewHeader = {
        heading: reviewTitle,
        description: '',
      };
      document.title = browserTabText;
      const emailTableAuthorableContent = {
        currentServicesHeading: currentServicesText,
        emailHeading: emailText,
        actionHeading: actionText,
        bulkActionHeading: bulkActionsText,
        migrateText: migrateRadioText,
        cancelText: cancelRadioText,
        migrateAllText: migrateAllRadioText,
        cancelAllText: cancelAllRadioText,
      };

      const reviewTableAuthorableContent = {
        emailHeading: emailText,
        actionHeading: actionText,
      };

      const forwardedTableAuthorableContent = {
        emailHeading: emailText,
        forwardedEmailHeading: forwardingEmailText,
      };

      const atleastOneMigratePresent = mailboxAffected.some(mailbox => this.state.emailSelectionCheckedStatus &&
        this.state.emailSelectionCheckedStatus[mailbox] === 'Migrate');

      return (
        <EventsAppWrapper>
          {this.state.currentScreen === BUSINESS_POP_MAIL_HOME_SCREEN &&
          <div className="business-pop-mail root-container container">
            <ViewHeader content={contentHeader} />
            {(altMailboxProvider === false && office365 === false) &&
            <React.Fragment>
              <div className="row">
                <div className="col-12 pl-sm-0">
                  <p className="short-summary">{renderHTML(stripStartingAndEndingPTags(shortSummary))}</p>
                </div>
              </div>
              <SummaryDetails summaryTitle={summaryTitle} summaryText={stripStartingAndEndingPTags(summary)} />
            </React.Fragment>
            }
            {altMailboxProvider === false && office365 === false && accountHolder === false &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="email-not-going-text">
                      {renderHTML(stripStartingAndEndingPTags(emailNotGoingToAccountHolderPre))} {domain}
                      {renderHTML(stripStartingAndEndingPTags(emailNotGoingToAccountHolderPost))}
                    </p>
                  </div>
                </div>
              </React.Fragment>
            }
            {thirdPartyDNS &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="thirdparty-dns-text">
                      {renderHTML(stripStartingAndEndingPTags(dns3rdPartyPre))} {domain}
                      {renderHTML(stripStartingAndEndingPTags(dns3rdPartyCenter))} {domain}
                      {renderHTML(stripStartingAndEndingPTags(dns3rdPartyPost))}
                    </p>
                  </div>
                </div>
              </React.Fragment>
            }
            {smtpMailbox &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="smtp-mailbox-text">{renderHTML(smtpMailboxText)}</p>
                  </div>
                </div>
              </React.Fragment>
            }
            {aliasMail.length > 0 &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="alias-email-text">{renderHTML(aliasEmailAddress)}</p>
                  </div>
                </div>
                <AliasTable tableHeading={aliasEmailAddressText} aliasEmailList={aliasMail} customClass="pl-sm-0" />
              </React.Fragment>
            }
            {emailForwarding &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="email-forwarding-text">{renderHTML(emailForwardingText)}</p>
                  </div>
                </div>
                <ForwardedEmailTable
                  authorableContent={forwardedTableAuthorableContent}
                  emailList={forwardedMailList}
                />
              </React.Fragment>
            }
            {mailOnServer &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="email-downloaded-text">{renderHTML(emailOnServerDownloaded)}</p>
                  </div>
                </div>
              </React.Fragment>
            }
            {office365 &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="office-365-text">{renderHTML(usingOffice365)}</p>
                  </div>
                </div>
              </React.Fragment>
            }
            {strayMail &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="stray-email-text">{renderHTML(customerStrayEmail)}</p>
                  </div>
                </div>
              </React.Fragment>
            }
            {altMailboxProvider &&
              <React.Fragment>
                <div className="row">
                  <div className="col-12 pl-sm-0">
                    <p className="hosted-anotherparty-text">{renderHTML(mailboxHostedAnotherParty)}</p>
                  </div>
                </div>
              </React.Fragment>
            }
            {altMailboxProvider === false && office365 === false &&
              <React.Fragment>
                <SummaryDetails summaryTitle={whatsNextSummaryTitle} summaryText={stripStartingAndEndingPTags(whatsNextSummary)} />
                <EmailTable
                  authorableContent={emailTableAuthorableContent}
                  emailList={mailboxAffected}
                  emailSelectionCheckedStatus={this.state.emailSelectionCheckedStatus}
                  onEmailSelectionStatusChanged={this.onEmailSelectionStatusChanged}
                  onAllSelectionChanged={this.onAllSelectionChanged}
                />
                {atleastOneMigratePresent &&
                <React.Fragment>
                  <div className="row">
                    <div className="col-12 pl-sm-0">
                      <div className="contact-field-description">{contactFieldDescription}</div>
                    </div>
                  </div>
                  <ContactForm
                    authorableContent={formFields}
                    contactFormValue={this.state.contactFormValue}
                    contactFormError={this.state.contactFormError}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  />
                </React.Fragment>
                }
                <div className="row">
                  <div className="col-12 text-right mobile-space">
                    <Button
                      className="button do-business"
                      buttonText={reviewAndSubmitButtonText}
                      disabled
                      onClick={this.onHandleReview}
                    />
                  </div>
                </div>
              </React.Fragment>
            }
            {(altMailboxProvider || office365) &&
              <React.Fragment>
                <SummaryDetails summaryTitle={whatsNextSummaryTitle} summaryText={stripStartingAndEndingPTags(whatsNextSummaryV2)} />
                <AliasTable tableHeading={affectedMailAddressesHeading} aliasEmailList={mailboxAffected} customClass="special-border" />
                <span className="footer-text">{footerText}</span>
              </React.Fragment>
            }
          </div>
          }
          {this.state.currentScreen === BUSINESS_POP_MAIL_REVIEW_SCREEN &&
            <div className="business-pop-mail root-container container">
              <ViewHeader content={reviewHeader} />
              <SummaryDetails summaryTitle={reviewSummaryTitle} summaryText={stripStartingAndEndingPTags(reviewSummary)} />
              <ReviewTable
                authorableContent={reviewTableAuthorableContent}
                emailList={mailboxAffected}
                emailSelectionCheckedStatus={this.state.emailSelectionCheckedStatus}
              />
              {atleastOneMigratePresent &&
              <div className="row">
                <div className="col-12 pl-sm-0">
                  <p className="short-summary">{renderHTML(stripStartingAndEndingPTags(migrationNote))}</p>
                </div>
              </div>
              }
              {atleastOneMigratePresent &&
              <div className="row contact-field-review">
                <div className="col-md-4 col-sm-12 contact-item">
                  <span><b>{formFields.firstName.label}</b> {this.state.contactFormValue.firstName}</span>
                </div>
                <div className="col-md-4 col-sm-12 contact-item">
                  <span><b>{formFields.lastName.label}</b> {this.state.contactFormValue.lastName}</span>
                </div>
                <div className="col-md-4 col-sm-12 contact-item">
                  <span><b>{formFields.contactField.label}</b> {this.state.contactFormValue.contactField}</span>
                </div>
                <div className="col-md-4 col-sm-12 contact-item">
                  <span><b>{formFields.email.label}</b> {this.state.contactFormValue.email}</span>
                </div>
                <div className="col-md-4 col-sm-12 contact-item">
                  <span><b>{formFields.accountNumber.label}</b> {this.state.contactFormValue.accountNumber}</span>
                </div>
                <div className="col-md-4 col-sm-12 contact-item">
                  <span><b>{formFields.abnNumber.label}</b> {this.state.contactFormValue.abnNumber}</span>
                </div>
                <div className="col-12">
                  <span><b>{formFields.billingAddress.label}</b> {this.state.contactFormValue.billingAddress}</span>
                </div>
              </div>
              }
              <div className="row">
                <div className="col-md-6 col-sm-6 edit-button mobile-space">
                  <Button
                    className="back-button do-business"
                    buttonText={editButtonText}
                    onClick={this.onHandleEdit}
                  />
                </div>
                <div className="col-md-6 col-sm-6 text-right mobile-space">
                  <Button
                    className="button do-business"
                    buttonText={submitButtonText}
                    onClick={this.onHandleSubmit}
                  />
                </div>

              </div>
              <Recaptcha
                ref={(ref) => { this.recaptcha = ref; }}
                sitekey="6Lc4EygUAAAAAARbXitF8Ce5SDM-mPst4SZV8Tbd"
                onResolved={this.onResolved}
                onError={this.onError}
                onExpired={this.onExpired}
              />

            </div>
          }
        </EventsAppWrapper>
      );
    }
    if (this.props.dataLoaded && this.props.enableNoAction === true) {
      const
        {
          businessMailServiceExit: {
            title: pageTitle,
            noActionHeading,
            noActionDescription,
            noActionFooter,
            affectedMailAddressesHeading,
          },
        } = this.props.authorableContent;
      const
        {
          mailboxAffected,
        } = this.props.customerData;

      const contentHeader =
        {
          heading: pageTitle,
          description: '',
        };
      return (
        <EventsAppWrapper>
          <div className="business-pop-mail root-container container">
            <ViewHeader content={contentHeader} />
            <SummaryDetails summaryTitle={noActionHeading} summaryText={stripStartingAndEndingPTags(noActionDescription)} />
            <AliasTable tableHeading={affectedMailAddressesHeading} aliasEmailList={mailboxAffected} customClass="special-border" />
            <div className="row">
              <div className="col-12 pl-sm-0">
                <p className="no-action-short-summary">{renderHTML(stripStartingAndEndingPTags(noActionFooter))}</p>
              </div>
            </div>
          </div>
        </EventsAppWrapper>
      );
    } else if (this.props.userSubmitted) {
      const {
        businessMailServiceExit: {
          title: userSubmittedTitle,
          alreadySubmittedHeading,
          alreadySubmittedDescription,
        },
      } = this.props.authorableContent;

      const userSubmittedHeader = {
        heading: userSubmittedTitle,
        description: '',
      };
      return (
        <EventsAppWrapper>
          <div className="business-pop-mail root-container container">
            <ViewHeader content={userSubmittedHeader} />
            <SummaryDetails summaryTitle={alreadySubmittedHeading} summaryText={stripStartingAndEndingPTags(alreadySubmittedDescription)} />
          </div>
        </EventsAppWrapper>
      );
    }

    if (this.props.formSubmitted) {
      const {
        confirmation: {
          title: confirmationTitle,
          summaryTitle: confirmationSummaryTitle,
          migratesummary,
          cancelsummary,
        },
      } = this.props.authorableContent;

      const {
        mailboxAffected,
      } = this.props.customerData;

      const atleastOneMigratePresent = mailboxAffected.some(mailbox => this.state.emailSelectionCheckedStatus &&
        this.state.emailSelectionCheckedStatus[mailbox] === 'Migrate');

      if (atleastOneMigratePresent) {
        this.setupTAMRedirect();
      }

      const confirmationHeader = {
        heading: confirmationTitle,
        description: '',
      };
      return (
        <EventsAppWrapper>
          <div className="business-pop-mail root-container container">
            <ViewHeader content={confirmationHeader} />
            {atleastOneMigratePresent &&
              <SummaryDetails summaryTitle={confirmationSummaryTitle} summaryText={stripStartingAndEndingPTags(migratesummary)} />
            }
            {!atleastOneMigratePresent &&
              <SummaryDetails summaryTitle={confirmationSummaryTitle} summaryText={stripStartingAndEndingPTags(cancelsummary)} />
            }
          </div>
        </EventsAppWrapper>
      );
    }

    return <Loader />;
  }
}
export default BusinessPopMailView;
